import React, { useEffect } from 'react';
import { useHeaderContext } from '../../context/headerContext';
import Button from '../../components/Button';
import { useLocation } from 'react-router-dom';
import { useUserContext } from '../../context/userContext';
import fetchWithRefresh from '../../utils/fetchWithRefresh';
import { toast } from "react-toastify";
import * as Sentry from "@sentry/react";
import { LogErrors } from "../../utils/LogErrors";

export default function CheckoutSuccess() {
    const { user, logout, updateTokens } = useUserContext();
    const { setTitle, setBackButton } = useHeaderContext();
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const paymentIntent = queryParams.get("paymentIntent");
 
    useEffect(() => {
        setTitle("Checkout");
        setBackButton(false);
    }, []);

    useEffect(() => {
        if(paymentIntent){
            updateSMSCount();
        }
    }, [paymentIntent])

    const updateSMSCount = async () => {
        try {
          return await Sentry.startSpan({ name: "Update SMS Count", op: "http.request" }, async (span) => {
            const url = `${import.meta.env.VITE_API_URL}Stripe/RecordSMSPurchase/?paymentIntentId=${paymentIntent}&userLoginId=${user?.id}`;
            span.setAttribute("http.url", url);
            span.setAttribute("userLoginId", user?.id);
      
            const response = await fetchWithRefresh(url, {
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${user.token}`,
              },
            }, logout, updateTokens, (message) => { toast.info(message); });
      
            if (response.ok) {
              span.setStatus("ok");
              return;
            } else {
              const errorMessage = `Error updating SMS count. Status: ${response.status}`;
              span.setStatus("error");
              Sentry.captureMessage(errorMessage, "warning");
              LogErrors(user, logout, updateTokens, errorMessage);
            }
          });
        } catch (error) {
          Sentry.captureException(error, { extra: { userLoginId: user?.id } });
          LogErrors(user, logout, updateTokens, "Error updating SMS count: " + error);
        }
      };

    return (
        <div className='flex flex-col gap-6'>
            <svg width="41" height="40" viewBox="0 0 41 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M1 20C1 9.23045 9.73045 0.5 20.5 0.5C31.2696 0.5 40 9.23045 40 20C40 30.7696 31.2696 39.5 20.5 39.5C9.73045 39.5 1 30.7696 1 20Z" fill="#47B405" stroke="#E3E3E3"/>
                <path d="M18.0466 27.3902C18.4372 27.7929 19.1013 27.7929 19.4919 27.3902L30.9763 15.5497C31.3669 15.1469 31.3669 14.4623 30.9763 14.0595L29.57 12.6097C29.1794 12.2069 28.5544 12.2069 28.1638 12.6097L18.7888 22.2754L14.3747 17.7647C13.9841 17.362 13.3591 17.362 12.9684 17.7647L11.5622 19.2146C11.1716 19.6173 11.1716 20.302 11.5622 20.7047L18.0466 27.3902Z" fill="white"/>
            </svg>
            <h2>Payment Successful!</h2>
            <p>Your SMS credits have been activated and are ready for use. Thank you for your purchase.</p>
            <div className='flex flex-col gap-4 pt-6 border-dashed border-t border-[#E3E3E3]'>
                <Button href="/" className="w-full">Go Home</Button>
            </div>
        </div>
    );
};